import React, { useState, useEffect, useRef } from "react";
import "./index.scss";
import _ from "lodash";

const PickTime = ({ config }) => {
  const value = _.get(config, "value", "00:00");
  const onChange = _.get(config, "onChange");

  const [showDropdown, setShowDropdown] = useState(false);
  const [time, setTime] = useState({
    hour: "00",
    minute: "00",
  });

  const pickerRef = useRef(null);

  useEffect(() => {
    const [hour, minute] = value.split(":");
    setTime({
      hour: hour || "00",
      minute: minute || "00",
    });
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const handleTimeChange = (type, value) => {
    const newTime = { ...time, [type]: value };
    setTime(newTime);

    if (onChange) {
      onChange(`${newTime.hour}:${newTime.minute}`);
    }
  };

  return (
    <div className="pick-time" style={{ width: "100%" }} ref={pickerRef}>
      <button
        className="toggle-btn"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
        onClick={toggleDropdown}
      >
        <div>
          <i className="fa fa-clock"></i> {time.hour}:{time.minute}
        </div>
        <span>▼</span>
      </button>

      {showDropdown && (
        <div className="time-dropdown">
          <div className="time-select">
            <select
              value={time.hour}
              onChange={(e) => handleTimeChange("hour", e.target.value)}
            >
              {Array.from({ length: 24 }, (_, i) => (
                <option key={i} value={String(i).padStart(2, "0")}>
                  {String(i).padStart(2, "0")}
                </option>
              ))}
            </select>
            :
            <select
              value={time.minute}
              onChange={(e) => handleTimeChange("minute", e.target.value)}
            >
              {Array.from({ length: 60 }, (_, i) => (
                <option key={i} value={String(i).padStart(2, "0")}>
                  {String(i).padStart(2, "0")}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default PickTime;
